export default __webpack_public_path__ + "static/media/element.03ee0d86.png";